// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__va3Xp","description":"PatientConsentPreview_description__1M9V5"};